import { writable } from 'svelte/store';

export const unreadCount = writable(0);
